// FETCH NEW QUOTATION
export const FETCH_NEW_QUOTATION_REQUEST = 'FETCH_NEW_QUOTATION_REQUEST';
export const FETCH_NEW_QUOTATION_SUCCESS = 'FETCH_NEW_QUOTATION_SUCCESS';
export const FETCH_NEW_QUOTATION_FAIL = 'FETCH_NEW_QUOTATION_FAIL';
// FETCH NEW QUOTATION AS SALESROUTE
export const FETCH_NEW_QUOTATION_SR_REQUEST = 'FETCH_NEW_QUOTATION_SR_REQUEST';
export const FETCH_NEW_QUOTATION_SR_SUCCESS = 'FETCH_NEW_QUOTATION_SR_SUCCESS';
export const FETCH_NEW_QUOTATION_SR_FAIL = 'FETCH_NEW_QUOTATION_SR_FAIL';
// FETCH QUOTATION
export const FETCH_QUOTATION_REQUEST = 'FETCH_QUOTATION_REQUEST';
export const FETCH_QUOTATION_SUCCESS = 'FETCH_QUOTATION_SUCCESS';
export const FETCH_QUOTATION_FAIL = 'FETCH_QUOTATION_FAIL';
// FETCH QUOTATION AS SALESROUTE
export const FETCH_QUOTATION_SR_REQUEST = 'FETCH_QUOTATION_SR_REQUEST';
export const FETCH_QUOTATION_SR_SUCCESS = 'FETCH_QUOTATION_SR_SUCCESS';
export const FETCH_QUOTATION_SR_FAIL = 'FETCH_QUOTATION_SR_FAIL';
// FETCH CALCULATE QUOTATION
export const FETCH_CALCULATE_REQUEST = 'FETCH_CALCULATE_REQUEST';
export const FETCH_CALCULATE_ONLY_REQUEST = 'FETCH_CALCULATE_ONLY_REQUEST';
export const FETCH_CALCULATE_SUCCESS = 'FETCH_CALCULATE_SUCCESS';
export const FETCH_CALCULATE_FAIL = 'FETCH_CALCULATE_FAIL';
// FETCH CALCULATE QUOTATION AS SALESROUTE
export const FETCH_CALCULATE_SR_REQUEST = 'FETCH_CALCULATE_SR_REQUEST';
export const FETCH_CALCULATE_ONLY_SR_REQUEST = 'FETCH_CALCULATE_ONLY_SR_REQUEST';
export const FETCH_CALCULATE_SR_SUCCESS = 'FETCH_CALCULATE_SR_SUCCESS';
export const FETCH_CALCULATE_SR_FAIL = 'FETCH_CALCULATE_SR_FAIL';
// PUT QUOTATION
export const PUT_QUOTATION_REQUEST = 'PUT_QUOTATION_REQUEST';
export const PUT_QUOTATION_SUCCESS = 'PUT_QUOTATION_SUCCESS';
export const PUT_QUOTATION_FAIL = 'PUT_QUOTATION_FAIL';
// PUT QUOTATION AS SALESROUTE
export const PUT_QUOTATION_SR_REQUEST = 'PUT_QUOTATION_SR_REQUEST';
export const PUT_QUOTATION_SR_SUCCESS = 'PUT_QUOTATION_SR_SUCCESS';
export const PUT_QUOTATION_SR_FAIL = 'PUT_QUOTATION_SR_FAIL';
// SUBMIT QUOTATION
export const SUBMIT_QUOTATION_REQUEST = 'SUBMIT_QUOTATION_REQUEST';
export const SUBMIT_QUOTATION_SUCCESS = 'SUBMIT_QUOTATION_SUCCESS';
export const SUBMIT_QUOTATION_FAIL = 'SUBMIT_QUOTATION_FAIL';
// CANCEL QUOTATION
export const CANCEL_QUOTATION_REQUEST = 'CANCEL_QUOTATION_REQUEST';
export const CANCEL_QUOTATION_SUCCESS = 'CANCEL_QUOTATION_SUCCESS';
export const CANCEL_QUOTATION_FAIL = 'CANCEL_QUOTATION_FAIL';
// CANCEL QUOTATION AS SALESROUTE
export const CANCEL_QUOTATION_SR_REQUEST = 'CANCEL_QUOTATION_SR_REQUEST';
export const CANCEL_QUOTATION_SR_SUCCESS = 'CANCEL_QUOTATION_SR_SUCCESS';
export const CANCEL_QUOTATION_SR_FAIL = 'CANCEL_QUOTATION_SR_FAIL';
// PUTONHOLD QUOTATION
export const PUTONHOLD_QUOTATION_REQUEST = 'PUTONHOLD_QUOTATION_REQUEST';
export const PUTONHOLD_QUOTATION_SUCCESS = 'PUTONHOLD_QUOTATION_SUCCESS';
export const PUTONHOLD_QUOTATION_FAIL = 'PUTONHOLD_QUOTATION_FAIL';
// PRINT QUOTATION
export const PRINT_QUOTATION_REQUEST = 'PRINT_QUOTATION_REQUEST';
export const PRINT_QUOTATION_SUCCESS = 'PRINT_QUOTATION_SUCCESS';
export const PRINT_QUOTATION_FAIL = 'PRINT_QUOTATION_FAIL';
// PRINT QUOTATION AS SALESROUTE
export const PRINT_QUOTATION_SR_REQUEST = 'PRINT_QUOTATION_SR_REQUEST';
export const PRINT_QUOTATION_SR_SUCCESS = 'PRINT_QUOTATION_SR_SUCCESS';
export const PRINT_QUOTATION_SR_FAIL = 'PRINT_QUOTATION_SR_FAIL';
// DUPLICATE QUOTATION AS SALESROUTE
export const DUPLICATE_QUOTATION_SR_REQUEST = 'DUPLICATE_QUOTATION_SR_REQUEST';
export const DUPLICATE_QUOTATION_SR_SUCCESS = 'DUPLICATE_QUOTATION_SR_SUCCESS';
export const DUPLICATE_QUOTATION_SR_FAIL = 'DUPLICATE_QUOTATION_SR_FAIL';
// FETCH QUOTATIONS
export const FETCH_QUOTATIONS_REQUEST = 'FETCH_QUOTATIONS_REQUEST';
export const FETCH_QUOTATIONS_SUCCESS = 'FETCH_QUOTATIONS_SUCCESS';
export const FETCH_QUOTATIONS_FAIL = 'FETCH_QUOTATIONS_FAIL';
// FETCH QUOTATIONS AS SALESROUTE
export const FETCH_QUOTATIONS_SR_REQUEST = 'FETCH_QUOTATIONS_SR_REQUEST';
export const FETCH_QUOTATIONS_SR_SUCCESS = 'FETCH_QUOTATIONS_SR_SUCCESS';
export const FETCH_QUOTATIONS_SR_FAIL = 'FETCH_QUOTATIONS_SR_FAIL';
// FETCH PRODUCT
export const FETCH_PRODUCT_REQUEST = 'FETCH_PRODUCT_REQUEST';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
export const FETCH_PRODUCT_FAIL = 'FETCH_PRODUCT_FAIL';
// FETCH LENDERS
export const FETCH_LENDERS_REQUEST = 'FETCH_LENDERS_REQUEST';
export const FETCH_LENDERS_SUCCESS = 'FETCH_LENDERS_SUCCESS';
export const FETCH_LENDERS_FAIL = 'FETCH_LENDERS_FAIL';
// FETCH LENDER_ADDRESSES
export const FETCH_LENDER_ADDRESSES_REQUEST = 'FETCH_LENDER_ADDRESSES_REQUEST';
export const FETCH_LENDER_ADDRESSES_SUCCESS = 'FETCH_LENDER_ADDRESSES_SUCCESS';
export const FETCH_LENDER_ADDRESSES_FAIL = 'FETCH_LENDER_ADDRESSES_FAIL';
// FETCH (LOAN) KINDS
export const FETCH_KINDS_REQUEST = 'FETCH_KINDS_REQUEST';
export const FETCH_KINDS_SUCCESS = 'FETCH_KINDS_SUCCESS';
export const FETCH_KINDS_FAIL = 'FETCH_KINDS_FAIL';
// FETCH (LOAN) DEFERRALS
export const FETCH_DEFERRALS_REQUEST = 'FETCH_DEFERRALS_REQUEST';
export const FETCH_DEFERRALS_SUCCESS = 'FETCH_DEFERRALS_SUCCESS';
export const FETCH_DEFERRALS_FAIL = 'FETCH_DEFERRALS_FAIL';
// FETCH BANKS
export const FETCH_BANKS_REQUEST = 'FETCH_BANKS_REQUEST';
export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS';
export const FETCH_BANKS_FAIL = 'FETCH_BANKS_FAIL';
// REDIRECT
export const SET_REDIRECT = 'SET_REDIRECT';
// VALIDATE_IBAN_REQUEST
export const VALIDATE_IBAN_REQUEST = 'VALIDATE_IBAN_REQUEST';
export const VALIDATE_IBAN_SUCCESS = 'VALIDATE_IBAN_SUCCESS';
export const VALIDATE_IBAN_FAIL = 'VALIDATE_IBAN_FAIL';
// SUBMIT QUOTATIONS
export const SUBMIT_QUOTATIONS_REQUEST = 'SUBMIT_QUOTATIONS_REQUEST';
export const SUBMIT_ONLY_QUOTATIONS_REQUEST = 'SUBMIT_ONLY_QUOTATIONS_REQUEST';
export const SUBMIT_QUOTATIONS_SUCCESS = 'SUBMIT_QUOTATIONS_SUCCESS';
export const SUBMIT_QUOTATIONS_FAIL = 'SUBMIT_QUOTATIONS_FAIL';
// SUBMIT QUOTATIONS AS SALESROUTE
export const SUBMIT_QUOTATIONS_SR_REQUEST = 'SUBMIT_QUOTATIONS_SR_REQUEST';
export const SUBMIT_ONLY_QUOTATIONS_SR_REQUEST = 'SUBMIT_ONLY_QUOTATIONS_SR_REQUEST';
export const SUBMIT_QUOTATIONS_SR_SUCCESS = 'SUBMIT_QUOTATIONS_SR_SUCCESS';
export const SUBMIT_QUOTATIONS_SR_FAIL = 'SUBMIT_QUOTATIONS_SR_FAIL';
// VALIDATE_QUOTATION
export const VALIDATE_QUOTATION_REQUEST = 'VALIDATE_QUOTATION_REQUEST';
export const VALIDATE_QUOTATION_SUCCESS = 'VALIDATE_QUOTATION_SUCCESS';
export const VALIDATE_QUOTATION_FAIL = 'VALIDATE_QUOTATION_FAIL';
// VALIDATE_QUOTATION AS SALESROUTE
export const VALIDATE_QUOTATION_SR_REQUEST = 'VALIDATE_QUOTATION_SR_REQUEST';
export const VALIDATE_QUOTATION_SR_SUCCESS = 'VALIDATE_QUOTATION_SR_SUCCESS';
export const VALIDATE_QUOTATION_SR_FAIL = 'VALIDATE_QUOTATION_SR_FAIL';
// NEED_RECALCULATE
export const NEED_RECALCULATE = 'NEED_RECALCULATE';
// RESET_OFFER
export const RESET_OFFER = 'RESET_OFFER';
